import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Speedometer from './Speedometer';

import './styles.less';

const I18N_BASE_PATH =
  'pages.private.KYBCompany.pages.companyDetails.components.riskLevelControl';

const RiskLevelControl = ({ onOpenModal, riskLevel, toPrint }) => {
  const { t: translate } = useTranslation();

  const riskLevelNumberValue = {
    0: 1.333,
    50: 2,
    100: 2.666,
  };

  // eslint-disable-next-line radix
  const hasRiskLevel = useMemo(() => !Number.isNaN(parseInt(riskLevel)), [riskLevel]);

  return (
    <div className="KYB-risk-level-control">
      <span className="risk-level-control-title mrg-btm-15 company-print-no-render">
        {translate(`${I18N_BASE_PATH}.title`, 'RISK LEVEL')}
      </span>
      <div className="flex-column center width-100">
        <span className="risk-level-title">
          {translate(`${I18N_BASE_PATH}.levels.${riskLevel}`, '-')}
        </span>
        <Speedometer value={riskLevelNumberValue[riskLevel]} toPrint={toPrint} />
        {!hasRiskLevel && (
          <h6 className="risk-level-subtitle company-print-no-render">
            {translate(`${I18N_BASE_PATH}.valueNoSet`, 'No value has been set')}
          </h6>
        )}
      </div>
      <div className="width-100 text-right text-bold mrg-top-10 company-print-no-render">
        <a
          href="/#"
          rel="noreferrer"
          onClick={(e) => {
            e.preventDefault();
            onOpenModal();
          }}
        >
          {hasRiskLevel
            ? translate(`${I18N_BASE_PATH}.buttons.changeLevel`, 'Change')
            : translate(`${I18N_BASE_PATH}.buttons.setARiskLevel`, 'Set a risk level')}
        </a>
      </div>
    </div>
  );
};

export default RiskLevelControl;

RiskLevelControl.propTypes = {
  onOpenModal: PropTypes.func.isRequired,
  riskLevel: PropTypes.number,
  toPrint: PropTypes.bool,
};

RiskLevelControl.defaultProps = {
  riskLevel: undefined,
  toPrint: false,
};
